@let state = notificationsState();

<button class="bell-button" [cdkMenuTriggerFor]="notificationMenu" i18n-aria-label aria-label="Notifications">
  <i class="ph-duotone ph-bell" aria-hidden="true"></i>
  <span class="badge" [class.error]="state.isError">{{ badgeText() }}</span>
</button>

<ng-template #notificationMenu>
  <div class="notification-panel" cdkMenu>
    <div class="panel-header">
      <span i18n>Notifications</span>
      @if (state.isReady && state.data.length > 0) {
        <button class="clear-all-button" (click)="clearAll()" i18n>Clear all</button>
      }
    </div>
    @switch (state.tag) {
      @case ('fetching') {
        <alg-loading class="panel-loading" />
      }
      @case ('error') {
        <alg-error class="panel-error"
          i18n-message message="Error loading notifications"
          icon="ph-duotone ph-warning-circle"
         />
      }
      @case ('ready') {
        @let data = state.data;
        @if (data.length === 0) {
          <div class="empty-state" i18n>No notifications</div>
        } @else {
          <ul class="notification-list">
            @for (notification of data; track notification.sk) {
              <!--
                Trash is a sibling of the cdkMenuItem (not nested inside role=menuitem) for ARIA.
                CDK menus typically move focus with arrows and Tab leaves the menu, so keyboard
                users still primarily activate via the row; trash remains pointer/touch-oriented.
              -->
              <li class="notification-row">
                <div
                  class="notification-item"
                  [attr.aria-busy]="(isGroupResultsExportReadyNotification(notification) && isDownloading(notification)) || null"
                  cdkMenuItem
                  (click)="onNotificationClick(notification)"
                >
                  @if (isForumNewMessageNotification(notification)) {
                    <i class="notification-icon ph-bold ph-chat-circle" aria-hidden="true"></i>
                    <div class="notification-content">
                      <div class="notification-text">{{ notification.payload.text }}</div>
                      <alg-relative-time class="notification-time" [value]="notification.payload.time | toDate" />
                    </div>
                  } @else if (isGroupResultsExportReadyNotification(notification)) {
                    <i class="notification-icon ph-bold ph-file-zip" aria-hidden="true"></i>
                    <div class="notification-content">
                      <div class="notification-text">{{ readySummary(notification) }}</div>
                      <!--
                        Export payloads have no created-at; `sk` is only a DynamoDB sort key for ordering/deletion
                        (forum rows use payload.time). Omit relative time rather than treating sk as milliseconds.
                      -->
                      @if (isExportLinkExpired(notification)) {
                        <div class="notification-secondary" i18n>Link expired</div>
                      } @else {
                        <div class="notification-secondary">
                          <ng-container i18n>Available until {{ notification.payload.expiresAt | date: 'medium' }}</ng-container>
                        </div>
                        <div class="notification-secondary" i18n>Click to download</div>
                      }
                      @if (isDownloading(notification)) {
                        <div class="notification-secondary" i18n>Preparing download…</div>
                      }
                    </div>
                  } @else if (isGroupResultsExportFailedNotification(notification)) {
                    <i class="notification-icon warning ph-bold ph-warning" aria-hidden="true"></i>
                    <div class="notification-content">
                      <div class="notification-text">
                        {{ failedSummary(notification.payload.groupName, notification.payload.error) }}
                      </div>
                    </div>
                  }
                </div>
                <button
                  type="button"
                  class="clear-button"
                  i18n-aria-label
                  aria-label="Clear notification"
                  (click)="onClearClick($event, notification)"
                >
                  <i class="ph-bold ph-trash" aria-hidden="true"></i>
                </button>
              </li>
            }
          </ul>
        }
      }
    }
  </div>
</ng-template>
